<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.additional.informations.label.title')}}</h4>

                            </div>
                        </div>
                    </div>
                    
                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.additional.informations.label.decription')}}
                                </p>

                                <form>
                                    <div class="form-row">
                                        <table class="table">
                                            <thead class="thead-dark">
                                                <td></td>
                                                <td>{{$t('response.company.workhours.register.monday')}}</td>
                                                <td>{{$t('response.company.workhours.register.tuesday')}}</td>
                                                <td>{{$t('response.company.workhours.register.wednesday')}}</td>
                                                <td>{{$t('response.company.workhours.register.thursday')}}</td>
                                                <td>{{$t('response.company.workhours.register.friday')}}</td>
                                                <td>{{$t('response.company.workhours.register.saturday')}}</td>
                                                <td>{{$t('response.company.workhours.register.sunday')}}</td>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{{$t('response.company.workhours.register.begin')}}</td>
                                                    <td>
                                                        <vue-timepicker v-model="data.monStart" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                    <td>
                                                        <vue-timepicker v-model="data.tueStart" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                    <td>
                                                        <vue-timepicker v-model="data.wedStart" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                    <td>
                                                        <vue-timepicker v-model="data.thuStart" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                    <td>
                                                        <vue-timepicker v-model="data.friStart" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                    <td>
                                                        <vue-timepicker v-model="data.satStart" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                    <td>
                                                        <vue-timepicker v-model="data.sunStart" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>{{$t('response.company.workhours.register.end')}}</td>
                                                    <td>
                                                        <vue-timepicker v-model="data.monEnd" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                    <td>
                                                        <vue-timepicker v-model="data.tueEnd" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                    <td>
                                                        <vue-timepicker v-model="data.wedEnd" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                    <td>
                                                        <vue-timepicker v-model="data.thuEnd" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                    <td>
                                                        <vue-timepicker v-model="data.friEnd" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                    <td>
                                                        <vue-timepicker v-model="data.satEnd" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                    <td>
                                                        <vue-timepicker v-model="data.sunEnd" :minute-interval="10" :format="'HH:mm'" class="    textDefaultColor "></vue-timepicker>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-12">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.payment.methods')}}
                                            </label>
                                            <div class="d-flex flex-wrap">
                                                <div class="container-switch" v-bind:key="item.id" v-for="item in this.paymentMethods">
                                                    <label class="switch">
                                                        <input 
                                                            v-model="data.paymentMethods" 
                                                            type="checkbox"
                                                            :id="item._id" 
                                                            :value="item._id"
                                                            :true-value="item._id"
                                                            :false-value="null"
                                                            >
                                                        <span class="slider round"></span>
                                                    </label>
                                                    <span class="label-swith">{{(item.name)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div v-bind:key="item.id" v-for="item in this.data.paymentMethods"> -->
                                        <div   class="form-row">
                                            <div class="form-group col-md-4">
                                                <label for="inputAddress" class="col-form-label">
                                                    <code class="highlighter-rouge">*</code>
                                                    {{$t('string.msg.card.x.acept.payment.label')}}
                                                </label>
                                                
                                                <select v-model="data.maxInstalments" class="form-control">
                                                    <option :value="1">{{$t('string.msg.card.x.acept.payment.select.one')}}</option>
                                                    <option :value="2">{{$t('string.msg.card.x.acept.payment.select.two')}}</option>
                                                    <option :value="3">{{$t('string.msg.card.x.acept.payment.select.three')}}</option>
                                                    <option :value="4">{{$t('string.msg.card.x.acept.payment.select.four')}}</option>
                                                    <option :value="5">{{$t('string.msg.card.x.acept.payment.select.five')}}</option>
                                                    <option :value="6">{{$t('string.msg.card.x.acept.payment.select.six')}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    <!-- </div> -->

                                    <label class="col-form-label">
                                        {{$t('string.msg.bank.title')}}
                                        <br/>
                                        <code class="highlighter-rouge">{{$t('string.msg.bank.infos')}}</code>
                                    </label>
                                    <br>
                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <code class="highlighter-rouge">*</code>
                                            <label class="col-form-label">
                                                {{$t('string.msg.select.bank.label')}}
                                            </label>
                                            <select id="banks" v-model="data.bankNumber" class="form-control">
                                                <option :value="null" selected>{{$t('string.msg.select.selector.item')}}</option>
                                                <option :value="Number(item.Code)" v-bind:key="item.Code" v-for="item in banks">{{item.Code +' - '+item.Name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.select.user.account.type')}}
                                            </label>
                                            <select v-model="data.bankAccountType" class="form-control">
                                                <option value="corrente">{{$t('string.msg.select.user.account.corrente')}}</option>
                                                <option value="poupanca">{{$t('string.msg.select.user.account.poupanca')}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        
                                        <div class="form-group col-md-1" v-show="data.bankNumber!=null">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.bank.number.agency.label')}}
                                            </label>
                                            <input type="text" v-mask="['####', '####-#', '####-##']" v-model="data.bankAgency" class="form-control" :placeholder="$t('string.msg.bank.number.agency.placeholder')">
                                        </div>
                                        <div class="form-group col-md-1" v-show="data.bankNumber!=null">
                                            <label class="col-form-label">
                                                {{$t('string.msg.bank.number.agency.digit.label')}}
                                            </label>
                                            <input type="text" v-mask="['####', '####-#', '####-##']" v-model="data.bankAgencyVerificationCode" class="form-control" :placeholder="$t('string.msg.bank.number.agency.placeholder')">
                                        </div>
                                        <div class="form-group col-md-2" v-show="data.bankNumber!=null">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.bank.number.account.label')}}
                                            </label>
                                           <input type="text" v-mask="['#####-#', '######-#', '#######-#', '########-#', '#########-#', '###########-#']" v-model="data.bankAccountNumber" class="form-control" :placeholder="$t('string.msg.bank.number.account.placeholder')">
                                        </div>
                                        <div class="form-group col-md-1" v-show="data.bankNumber!=null">
                                            <label class="col-form-label">
                                                {{$t('string.msg.bank.number.account.digit.label')}}
                                            </label>
                                           <input type="text" v-mask="['#####-#', '######-#', '#######-#', '########-#', '#########-#', '###########-#']" v-model="data.bankAccountVerificationCode" class="form-control" :placeholder="$t('string.msg.bank.number.account.placeholder')">
                                        </div>
                                      
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.select.user.document.type')}}
                                            </label>
                                            <select v-model="data.bankDocumentType" class="form-control">
                                                <option value="cnpj">{{$t('string.msg.select.user.document.cnpj')}}</option>
                                                <option value="cpf">{{$t('string.msg.select.user.document.cpf')}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-3" v-show="data.bankNumber!=null">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.bank.number.document.label')}}
                                            </label>
                                             <span class="col-form-label cursor-pointer" @click="getCNPJ()">
                                                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                 {{$t('string.msg.use.data.my.self.cnpj.label')}}
                                            </span>
                                           <input v-if="data.bankDocumentType=='cnpj'"  type="text" v-mask="'##.###.###/####-##'" v-model="data.bankDocument" class="form-control" :placeholder="$t('string.msg.bank.number.document.placeholder')">

                                           <input v-if="data.bankDocumentType=='cpf'"  type="text" v-mask="'###.###.###-##'" v-model="data.bankDocument" class="form-control" :placeholder="$t('string.msg.bank.number.document.placeholder')">
                                        </div>
                                        <div class="form-group col-md-8" v-show="data.bankNumber!=null">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.bank.company.name.label')}}
                                            </label>
                                             <span class="col-form-label cursor-pointer" @click="getSocialName()">
                                                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                 {{$t('string.msg.use.data.my.self.name.label')}}
                                            </span>
                                           <input type="text" v-model="data.bankNameOwner" class="form-control" :placeholder="$t('string.msg.bank.company.name.placeholder')">
                                        </div>
                                    </div>

                                    <br/>
                                    <div class="mb-3" style="text-align:right">
                                        <button  @click="save" class="btn btn-danger w-20 ">{{$t('string.msg.form.btn.save')}}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />

        <ModalTermParts  :dataCompany="dataCompany" v-on:confirmation-return="acceptedTermPurchase"/>
        <ModalTermCertifies  :dataCompany="dataCompany" v-on:confirmation-return="acceptedTermPurchase"/>
        <ModalTermServices  :dataCompany="dataCompany" v-on:confirmation-return="acceptedTermPurchase"/>
        <ModalTerm v-on:confirmation-return="acceptedTermGeneral"/>
        <FlashMessage/>
    </div>
</template>

<script>
import Controller from './CrtWorkHours';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Endpoints from '../../../components/common/Endpoints';
import Request from '../../../components/common/Request';
import Banks from './Banks/br-banks.js';
import VueTimepicker from 'vue2-timepicker'; //https://github.com/phoenixwong/vue2-timepicker

import ModalTerm from '../Modal/Term/ModalTerm';
import ModalTermParts from '../Modal/Term/ModalTermParts';
import ModalTermServices from '../Modal/Term/ModalTermService';
import ModalTermCertifies from '../Modal/Term/ModalTermCertifie';

export default {
  name: 'WorkHours',
  components: {
    Spinner,
    Toast,
    VueTimepicker,
    Controller,
    ModalTerm,
    ModalTermParts,
    ModalTermServices,
    ModalTermCertifies
  },
  data() {
      return {
        errors: [],
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        banks: Banks,
        paymentMethods: [
            {_id:"MONEY", name:this.$t('string.msg.company.label.payment.money')},
            {_id:"DEBIT_CARD", name:this.$t('string.msg.company.label.payment.debit.card')},
            {_id:"CREDIT_CARD", name:this.$t('string.msg.company.label.payment.credit.card')},
        ],
        data: {
            monStart:{
                HH: 8,
                mm: '00'
            },
            monEnd:{
                HH: 18,
                mm: '00'
            },
            tueStart: {
                HH: 8,
                mm: '00'
            },
            tueEnd: {
                HH: 18,
                mm: '00'
            },
            wedStart: {
                HH: 8,
                mm: '00'
            },
            wedEnd: {
                HH: 18,
                mm: '00'
            },
            thuStart: {
                HH: 8,
                mm: '00'
            },
            thuEnd: {
                HH: 18,
                mm: '00'
            },
            friStart: {
                HH: 8,
                mm: '00'
            },
            friEnd: {
                HH: 18,
                mm: '00'
            },
            satStart: {
                HH: 8,
                mm: '00'
            },
            satEnd: {
                HH: 13,
                mm: '00'
            },
            sunStart: {
                HH: '00',
                mm: '00'
            },
            sunEnd: {
                HH: '00',
                mm: '00'
            },
            isExternalMeet: false,
            paymentMethods: [],
            bankNumber: null,
            bankAgency: null,
            bankAccountVerificationCode: null,
            bankAgencyVerificationCode: null,
            bankAccountNumber: null,
            bankDocument: null,
            bankAccountType: 'corrente',
            bankDocumentType: 'cnpj',
            bankNameOwner: null,
            maxInstalments: 1,
        }
      }
  },
  methods: Controller.methods,
  created() {
  },
  mounted(){
        Controller.init(this);
  }
}
</script>

<style>
</style>
